import { Grid, Paper, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from '@mui/material/Button';
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
    createFailedSampleNames, getClient, getDealer, getFailedSample, getInstitute,
    getSampleAccessioning, getSampleAccessioningFilter
} from "../../actions/GenomicsResearchAction";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
  })
);
interface Props {
  getClient: any;
  client: any;
  getInstitute: any;
  institute: any;
  getApplications: any;
  applications: any;
  projects: any;
  getProjects: any;
  createProject: any;
  updateProject: any;
  getDealer: any;
  dealer: any;
  sampleFilter: any;
  getSampleAccessioningFilter: any;
  createFailedSampleNames:any;
  getFailedSample:any;
  FailedSamples:any;

}
const StopsPlace: React.FC<Props> = ({
  getClient,
  client,
  getInstitute,
  institute,
  getDealer,
  dealer,
  sampleFilter,
  getSampleAccessioningFilter,
  createFailedSampleNames,
  getFailedSample,
  FailedSamples,

}) => {
  const classes = useStyles();
  const history = useHistory();
  const timer = useRef<any>(0);
  const [delName, setDelName] = useState<any>("");
  const [numOfPassSamples, setNumOfPassSamples] = useState<any>("");
  const [clientName, setClientgName] = useState<any>("");
  const [sampleNames, setSampleNames] = useState<any>([]);
  const { id } = useParams<{ id: string }>();
  const [clients, setClients] = React.useState<any>("");
  const [dealerName, setDealerName] = useState<any>("");
  const [insName, setInsName] = useState<any>("");
  const [instituteName, setInstituteName] = useState<any>("");
  const [isEdit, setIsEdit] = useState<any>(false);

  useEffect(() => {
    if (sampleFilter?.failedCount) {
      setSampleNames(new Array(sampleFilter?.failedCount).fill(""));
    }
  }, [sampleFilter]);

  // If sample registered then update sample data
  console.log("Failed samples",FailedSamples)
  useEffect(() => {
    if (FailedSamples?.names?.length) {
      setSampleNames([...FailedSamples?.names, ...new Array(sampleFilter?.failedCount - FailedSamples?.names?.length).fill("")]|| []);
    }
  }, [sampleFilter, FailedSamples]);

  const handleInputChange = (index: any, val: any) => {
    const newSampleNames = [...sampleNames];
    newSampleNames[index] = val;
    setSampleNames(newSampleNames);
  };

  const handleSamplesdata = async (e: any) => {
    e.preventDefault();
    const failedSamplesData = {
      names: sampleNames,
    };
    await createFailedSampleNames(failedSamplesData,sampleFilter?._id);
    history.push(`/dashboard/gnre/samples`);
  };
  useEffect(() => {
    getClient();
    getInstitute();
    getSampleAccessioningFilter(id);
    getDealer();
    getFailedSample(id);
  }, []);

  useEffect(() => {
    if (sampleFilter) {
      const sample = sampleFilter;
      setClients(sample?.scientist?._id)
      setClientgName(sample?.scientist?.name)
      setInstituteName(sample?.institute?._id)
      setInsName(sample?.institute?.name)
      setDealerName(sample?.dealer?._id)
      setDealerName(sample?.dealer?.name)
      setNumOfPassSamples(sample?.failedCount)
    }
  }, [sampleFilter]);


  return (
    <Grid container spacing={2}>
      <form onSubmit={handleSamplesdata} style={{ width: "100%" }}>
        <Paper style={{ margin: "70px auto", width: "80%", background: "#eff", marginTop: 40 }}>
          <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Register Failed Sample Name</h2>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="flex-end"
            spacing={2}
            style={{ margin: "1rem auto" }}
          >
            <Grid container spacing={2} style={{ marginLeft: 1 }}>
              <Grid item xs={12} sm={4} md={3}>
                <Autocomplete
                  id="client_name"
                  disablePortal
                  onChange={(event, newValue) => {
                    if (newValue) {
                      let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                      setClients(obj._id);
                    }
                  }}
                  options={client.results || ""}
                  inputValue={clientName || []}
                  disabled
                  getOptionLabel={(option: any) => `${option?.name}`}
                  onInputChange={(event, newInputValue) => {
                    clearTimeout(timer.current);
                    timer.current = setTimeout(() => {
                      getClient(newInputValue);
                    }, 1000);
                    setClientgName(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="input"
                      label="Client"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={3}>
                <Autocomplete
                  id="Institute"
                  disablePortal
                  onChange={(event, newValue) => {
                    if (newValue) {
                      let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                      setInstituteName(obj._id);
                    }
                  }}
                  inputValue={insName || ""}
                  options={institute.results || []}
                  disabled
                  getOptionLabel={(option: any) => `${option?.name}`}
                  onInputChange={(event, newInputValue) => {
                    clearTimeout(timer.current);
                    timer.current = setTimeout(() => {
                      getInstitute(newInputValue);
                    }, 1000);
                    setInsName(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="input"
                      label="Institute Name"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={3}>
                <Autocomplete
                  id="Dealer"
                  disablePortal
                  key={dealer}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                      setDealerName(obj._id);
                    }
                  }}
                  defaultValue={
                    { id: "", name: delName }
                  }
                  inputValue={dealerName || ""}

                  options={dealer.results || []}
                  disabled
                  getOptionLabel={(option: any) => `${option?.name}`}
                  onInputChange={(event, newInputValue) => {
                    clearTimeout(timer.current);
                    timer.current = setTimeout(() => {
                      getDealer(newInputValue);
                    }, 1000);
                    setDelName(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="input"
                      label="Dealer Name"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={3}>
                <TextField
                  className="input"
                  name="title"
                  type="number"
                  fullWidth
                  label="Fail Samples"
                  value={numOfPassSamples || ""}
                  onChange={(e) => setNumOfPassSamples(e.target.value)}
                  disabled
                  variant="outlined"
                  style={{ margin: "0", width: "100%" }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            style={{ margin: "1rem auto", background: "#E0F2F1" }}
          >
            {sampleNames.map((value: string, index: number) => (
              <Grid item xs={12} sm={4} md={2}>
                <TextField
                  label="Sample Name"
                  variant="outlined"
                  className="input"
                  fullWidth
                  value={value}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                />
              </Grid>
            ))}
          </Grid>
          <Grid xs={12} style={{ textAlign: "center", padding: "20px" }}>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              style={{ width: 300 }}

            >
              Register
            </Button>
          </Grid>
        </Paper>
      </form>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  client: state.GenomicsCAReducer.client,
  institute: state.GenomicsCAReducer.institute,
  samplesAccessioning: state.GenomicsCAReducer.samplesAccessioning,
  dealer: state.GenomicsCAReducer.dealer,
  sampleFilter: state.GenomicsCAReducer.sampleFilter,
  FailedSamples: state.GenomicsCAReducer.FailedSamples,

});
export default connect(mapStateToProps, {
  getClient,
  getInstitute,
  getSampleAccessioning,
  getDealer,
  getSampleAccessioningFilter,
  createFailedSampleNames,
  getFailedSample,
})(StopsPlace);
